const ENDPOINT = process.env.NODE_ENV === 'production' ? 'https://fantasy.amateum.com/book/' : 'http://localhost:3500/book/'
const BET_SIZE = 100

export { ENDPOINT, BET_SIZE }
